<div>
	<span translate>
		quality.issues.submitted.successfully
	</span>
</div>
<div class="claim-follow-up">
	<span class="claim-follow-up-text" translate>
		quality.issues.followup
	</span>
</div>